import { IconAlertTriangle as TablerIconAlertTriangle } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconAlertTriangle = /*#__PURE__*/ createOutlineIcon(
  TablerIconAlertTriangle,
  'IconAlertTriangle',
);
